const MAX_SLOT_SORT_VALUE = Number.MAX_SAFE_INTEGER;

function parseTimeSlotStart(slot) {
  const raw = String(slot || "").split("-")[0].trim();
  const match = raw.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);

  if (!match) {
    return null;
  }

  let hours = Number(match[1]) % 12;
  const minutes = Number(match[2]);

  if (match[3].toUpperCase() === "PM") {
    hours += 12;
  }

  return (hours * 60) + minutes;
}

export function getOrderStatusId(orderRow) {
  const value = Number(orderRow?.order?.order_status_id ?? orderRow?.order_status_id ?? 0);
  return Number.isFinite(value) ? value : 0;
}

export function getOrderWorkflowTimeSlot(orderRow) {
  const statusId = getOrderStatusId(orderRow);
  const pickupSlot =
    orderRow?.pickup_time_slot ??
    orderRow?.pickup_slot ??
    orderRow?.order?.pickup_time_slot ??
    orderRow?.time_slot ??
    "";
  const dropoffSlot =
    orderRow?.dropoff_time_slot ??
    orderRow?.dropoff_slot ??
    orderRow?.order?.dropoff_time_slot ??
    "";

  if (statusId === 17) {
    return dropoffSlot || pickupSlot;
  }

  if (statusId === 2) {
    return pickupSlot || dropoffSlot;
  }

  return dropoffSlot || pickupSlot;
}

export function getOrderWorkflowSlotSortValue(orderRow) {
  const parsedStart = parseTimeSlotStart(getOrderWorkflowTimeSlot(orderRow));

  if (parsedStart !== null) {
    return parsedStart;
  }

  const fallback = Number(orderRow?.order?.timeslot_sort ?? orderRow?.timeslot_sort);
  if (Number.isFinite(fallback)) {
    return fallback * 60;
  }

  return MAX_SLOT_SORT_VALUE;
}

export function getOrderTimeslotSortValue(orderRow) {
  const value = Number(orderRow?.order?.timeslot_sort ?? orderRow?.timeslot_sort);

  if (Number.isFinite(value)) {
    return value;
  }

  return null;
}

export function compareOrdersByTimeslotSort(left, right) {
  const leftTimeslotSort = getOrderTimeslotSortValue(left);
  const rightTimeslotSort = getOrderTimeslotSortValue(right);

  if (leftTimeslotSort !== null && rightTimeslotSort !== null && leftTimeslotSort !== rightTimeslotSort) {
    return leftTimeslotSort - rightTimeslotSort;
  }

  if (leftTimeslotSort !== null && rightTimeslotSort === null) {
    return -1;
  }

  if (leftTimeslotSort === null && rightTimeslotSort !== null) {
    return 1;
  }

  const slotDiff = getOrderWorkflowSlotSortValue(left) - getOrderWorkflowSlotSortValue(right);
  if (slotDiff !== 0) {
    return slotDiff;
  }

  return 0;
}
/**
 * On-site service window ("8:00 AM – 2:30 PM") for website orders that have
 * order_start_time / order_end_time instead of pickup/drop-off time slots.
 * Returns "" when the order has no service window.
 */
export function getServiceWindow(orderRow) {
  const o = orderRow?.order ?? orderRow ?? {};
  const start = o.order_start_time;
  const end = o.order_end_time;
  if (!start || !end) return "";

  const fmt = (t) => {
    const [h, m] = String(t).split(":");
    const hour = Number(h);
    if (Number.isNaN(hour)) return String(t);
    const ampm = hour >= 12 ? "PM" : "AM";
    const h12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${h12}:${m} ${ampm}`;
  };

  return `${fmt(start)} – ${fmt(end)}`;
}
